import { styled, createStyles, makeStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
export const LinkItemCont = styled('div')(({ theme }) => ({
  background: theme.palette.type === 'dark' ? '#1f2733' : '#f7f7f7',
  padding: '10px 20px',
  cursor: 'pointer',
  //hover effect
  '&:hover': {
    backgroundColor: theme.palette.type === 'dark' ? '#1c2530' : '#e4e8f0',
  },
  borderRadius: 8,
  display: 'flex',
  gap: 10,
  alignItems: 'center',
}));

export const useStyles = makeStyles((theme) =>
  createStyles({
    toolTip: {
      background: (theme.palette.type === 'dark' ? COLORS.DARK_BACKGROUND : COLORS.WHITE) + '!important',
    },
  }),
);
